import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer 
      className="bg-slate-900 text-slate-400"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* About Section */}
          <div className="lg:col-span-2">
            <h3 className="font-heading text-xl font-semibold text-white mb-4">
              Muscle & Movement Rehab
            </h3>
            <p className="text-slate-400 leading-relaxed mb-4">
              We are committed to your health and fitness. Our team of experienced practitioners 
              offers patient-focused, evidence-based treatment plans tailored to your specific needs.
            </p>
            <p className="text-sm text-slate-500">
              Services: Physiotherapy, Chiropractic, Registered Massage Therapy, Naturopathic Care, Fitness Programs, Orthotics & Wellness Products
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-white mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="tel:+16474903782" 
                  className="flex items-start space-x-3 hover:text-[#7FFF00] transition-colors footer-link"
                  data-testid="footer-phone-link"
                >
                  <Phone className="h-5 w-5 mt-0.5 flex-shrink-0" />
                  <span>+1 647-490-3782</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:admin@muscleandmovement.com" 
                  className="flex items-start space-x-3 hover:text-[#7FFF00] transition-colors footer-link"
                  data-testid="footer-email-link"
                >
                  <Mail className="h-5 w-5 mt-0.5 flex-shrink-0" />
                  <span>admin@muscleandmovement.com</span>
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span>5800 Sheppard Avenue East, Unit 13<br />Scarborough, ON M1B 5J7</span>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/privacy-policy" 
                  className="hover:text-[#7FFF00] transition-colors footer-link"
                  data-testid="footer-privacy-link"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms-conditions" 
                  className="hover:text-[#7FFF00] transition-colors footer-link"
                  data-testid="footer-terms-link"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <a 
                  href="https://muscleandmovement.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-[#7FFF00] transition-colors footer-link"
                  data-testid="footer-main-site-link"
                >
                  Main Website
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-slate-500">
              © {currentYear} Muscle & Movement Rehab. All rights reserved.
            </p>
            <p className="text-xs text-slate-600 text-center md:text-right max-w-md">
              We use text messaging to help coordinate your care, including appointment reminders, 
              scheduling updates, and occasional clinic promotions if you opt in.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
